import { render, staticRenderFns } from "./sidebar.component.vue?vue&type=template&id=9e877cd6&scoped=true&"
import script from "./sidebar.component.vue?vue&type=script&lang=js&"
export * from "./sidebar.component.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.component.vue?vue&type=style&index=0&id=9e877cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e877cd6",
  null
  
)

export default component.exports